/* eslint-disable arrow-body-style */
import React, { useState, useRef } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardTitle, Button, Alert,
  InputGroup,
} from 'reactstrap';
import {
  Table, Tbody, Tr, Td,
} from 'react-super-responsive-table';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Can } from '../../utilities/Can';
import { get } from '../../helpers/api_helper';

function ChannelAdvisor(props) {
  const { t } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const saleId = useRef(null);

  const [triggerLoading, setTriggerLoading] = useState(false);
  const [triggerError, setTriggerError] = useState(null);
  const [triggerSingleLoading, setTriggerSingleLoading] = useState(false);
  const [triggerSingleError, setTriggerSingleError] = useState(null);

  const download = async () => {
    try {
      setTriggerLoading(true);
      await get('/api/ca/sales');
    } catch (error) {
      setTriggerError(error.message);
    } finally {
      setTriggerLoading(false);
    }
  };

  const downloadSingle = async () => {
    try {
      setTriggerSingleLoading(true);
      const ids = saleId.current.value.split(',').map((id) => id.trim()); // Split and trim whitespace
      const validIds = ids.filter((id) => id !== ''); // Filter out empty IDs

      if (validIds.length === 0) {
        toastr.warning(t('No valid sale IDs provided'));
        return;
      }

      // Use Promise.all to run all requests concurrently
      await Promise.all(
        validIds.map(async (id) => {
          await get(`/api/ca/sale/${id}`);
          toastr.success(t(`Sale ${id} downloaded`)); // Include ID for clarity
        }),
      );

      saleId.current.value = ''; // Clear the input after processing
    } catch (error) {
      setTriggerSingleError(error.message);
    } finally {
      setTriggerSingleLoading(false);
    }
  };

  const getUnlinked = async () => {
    try {
      const unl = await get('/api/ca/all-products');

      // eslint-disable-next-line no-console
      console.log(unl);
    } catch (error) {
      toastr.error(error.message);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="5">
            <Card>
              <CardBody>
                <CardTitle className="h4">{t('ChannelAdvisor Utilities')}</CardTitle>

                <Can i="see" this="bc">
                  <Table className="mt-3 table table-striped table-bordered">
                    <Tbody>
                      <Tr>
                        <Td>{props.t('Control Panel')}</Td>
                        <Td>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://complete.channeladvisor.com/?apid=12003175"
                          >
                            https://complete.channeladvisor.com/?apid=12003175
                          </a>
                        </Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </Can>

                <Can not i="see" this="bc"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Triggers')}</CardTitle>

                <div className="hstack gap-4 mt-3">
                  <div>
                    {triggerError !== null && (
                      <Alert color="error">{triggerError}</Alert>
                    )}
                    <Button color="light" onClick={download} disabled={triggerLoading}>{props.t('Download Sales')}</Button>
                  </div>

                  <div>
                    {triggerSingleError !== null && (
                      <Alert color="error">{triggerSingleError}</Alert>
                    )}
                    <InputGroup>
                      <input type="text" ref={saleId} className="form-control" />
                      <Button color="light" onClick={downloadSingle} disabled={triggerSingleLoading}>{props.t('Download Sale')}</Button>
                    </InputGroup>
                  </div>
                </div>

                <Button color="info" size="sm" onClick={getUnlinked}>
                  Get Unlinked
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

ChannelAdvisor.defaultProps = {
  t: (x) => (x),
};

ChannelAdvisor.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ChannelAdvisor));
